<script>

import { roundCloseButtonBlue } from '@project/themes'
import { ModalPositionCenter } from '@kit/components/Modal.vue'

export const modal = {
  windowAutoPosition: true,
  position: ModalPositionCenter,
  backgroundClasses: "fbicc-modal-background",
  windowClasses: "fbicc-modal-background",
  closeButton: roundCloseButtonBlue,
  windowStyles: { append: "background:#FFFFFF; box-shadow:6px 6px 5px #999999; border-radius:4px; border-left:2px solid #DDDDDD; border-top:2px solid #DDDDDD;" }
}

export default { "name":"theme-modal" }
</script>